import React from 'react';

function pad2(number) {
  return number < 10 ? '0' + number : String(number);
}

function UserGoalCheckCalendar({ checkDates, month, year }) {
  // Use current date if props are missing
  const now = new Date();
  const displayMonth = month ?? now.getMonth();
  const displayYear = year ?? now.getFullYear();

  // Calculate days in month
  const daysInMonth = new Date(displayYear, displayMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(displayYear, displayMonth, 1).getDay();

  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const blanks = Array.from({ length: firstDayOfMonth }, (_, i) => i);

const checkedDateStrings = new Set(
  checkDates.map(d => d.split('T')[0])
);
  return (
    <div className="calendar-mini-grid">
      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d,index) => (
        <div key={`${d}-${index}`} className="calendar-day-label">
      {d}
    </div>
      ))}

      {blanks.map((b) => (
        <div key={`b-${b}`} />
      ))}

      {days.map((day) => {
  // Construct the string for the specific cell we are rendering
  // Example: "2026-02-26"
  const dateString = `${displayYear}-${pad2(displayMonth + 1)}-${pad2(day)}`;
  
  // Direct string comparison is immune to timezone shifts!
  const isChecked = checkedDateStrings.has(dateString);

  const isToday =
    day === now.getDate() &&
    displayMonth === now.getMonth() &&
    displayYear === now.getFullYear();

  return (
    <div
      key={day}
      className={`calendar-day-cell ${isChecked ? 'checked' : ''} ${isToday ? 'today' : ''}`}
    >
      {day}
    </div>
  );
})}
    </div>
  );
}

export default UserGoalCheckCalendar;
